<template>

    <router-link
    v-if="internalLink"
    :to="path"
    class="nav-link main-link">
        <img :src="`../img/emoji/${emoji}.svg`" :alt="`${title} emoji`">
        <h3>{{title}}</h3>
        <p>{{text}}</p>
    </router-link>

    <a
    v-else
    :href="path"
    class="nav-link small-link"
    :target="target">
        <img :src="`../img/emoji/${emoji}.svg`" :alt="`${title} emoji`">
        <h3>{{title}}</h3>
        <p>{{text}}</p>
    </a>

</template>

<script>
import { Push } from 'vue-burger-menu'
import anime from 'animejs'

export default {
  props: ['internalLink', 'path', 'emoji', 'title', 'text', 'target'],
  components: { Push },
  data () {
    return {
    }
  },
  methods: {

  },
  mounted () {

  }

}
</script>

<style lang="scss">

.nav-link {
    background-color: $gray8;
    background-position: 0 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid $gray5;
    transition: all 200ms ease-out;

    h3, p {
        white-space: pre;
    }

    h3 {
        color: $white;
        font-family: $display-font;
        font-size: 1.75rem;
    }

    p {
        color: $gray3;
        text-transform: uppercase;
        font-size: 0.625rem;
        letter-spacing: .075rem;
    }

    img {
        width: 2rem;
        margin-bottom: .2rem;
        transition: all 200ms ease-out;
    }

    &:hover {
        background-color: $gray7;
        animation: moveBG 30s linear infinite;

        img {
            width: 3rem;
        }
    }
}

.main-link {
    flex-grow: 2;
    flex-grow: 1;

    &:hover {
        flex-grow: 2.5;
        flex-grow: 2;
    }
}

.small-link {
    flex-grow: 1;

    &:hover {
        flex-grow: 2;
    }
}

@keyframes moveBG {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -500% 0%;
    }
}

</style>
